import { Component, OnInit, Input, HostListener, OnChanges, SimpleChanges, ViewChild, ElementRef } from "@angular/core";
import { AppService } from '../app.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../shared/http.service';
import { Router } from '@angular/router';
import { CompanyService } from '../company/company.service';
import { CookieService } from 'ngx-cookie-service';
import { PrfAuthService } from "../prf-auth.service";


declare function loadCustomerSelectionJS(): any;
declare function checkFederatedUser(any): any;


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit,OnChanges {

  objectKeys = Object.keys;

  @ViewChild('signoutLink') signoutLink: ElementRef<HTMLAnchorElement>;
  @Input() productLists: any[];
  @Input() menuLists: any[];
  @Input() productTitle;
  @Input() helpUrl;
  @Input() categoryISOProducts: object;
  selProductList;
  scrollTop;
  showingProductDD: boolean = false;
  showingProfile: boolean = false;
  errorMessage: any;
  hover_megamenu;
  customername:string="";
  userISOProducts = [];
  isAdmin: boolean = false;
  isAdminorReadOnly: boolean = false;
  showSignOutLoader: boolean = false;
 

  constructor(
    private prfAuth: PrfAuthService,
    private AppService: AppService,
    private httpService: HttpService,
    private companyService: CompanyService,
    private router: Router,
    private cookieService: CookieService

  ) {

  }


  ngOnChanges(changes: SimpleChanges): void {
      this.updateMegamenu();
      this.removeConfigureMFAForFederatedUser();
  }


  private updateMegamenu() {
    if (this.productLists[0]) {
      this.productLists[0].items = this.userISOProducts;
      this.hover_megamenu = this.productLists[0].categoryTitle;
    }
  }

  ngOnInit(): void {
     const userId: string = this.httpService.getIsonetValue('userid');
     const ticket: string = this.prfAuth.accessToken();
     if(!this.cookieService.get("prd_ctx")){
      this.cookieService.set("prd_ctx",environment.ProductIdAlias)
    }
     this.AppService.getUserProducts(userId, ticket).subscribe({
      next: _userProducts => {

        // populate user products
        this.userISOProducts = _userProducts;
        this.updateMegamenu();
        
      },
      error: error => this.errorMessage = error
    });
    console.log("Calling loadCustomerSelectionJS().");
    this.customername = localStorage.getItem('customername');
    this.isAdminorReadOnly = this.AppService.isAdmin || this.AppService.isReadonlyAdmin;
  }
  @HostListener("window:scroll")
  onWindowScroll() {
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
  }

  closeProductDD = () => {
    if (this.showingProductDD) this.showingProductDD = false;
  };

  closeProfileMenu = () => {
    if (this.showingProfile) {
      this.showingProfile = false;
    }
  };

  showProductList(list) {
    this.selProductList = list;
  }

  openInNew(url) {

    this.companyService.getTemplateFile("ScreenHelp.pdf").subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          let fileurl = resp["templateurl"];
          window.open(fileurl, "_blank");
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      }
    });
  }
 
  navigateToHome() {
    this.router.navigate(['/']);
  }

  getLogoutUrl(): string {
    const appConfig = this.AppService.getGlobalConfig();
    return appConfig?.logoutUrl || '#';
  }

  appLogout(event: Event) {
    this.showSignOutLoader = true;
    event.preventDefault();
    const ticket = sessionStorage.getItem('access_token');
    
    this.companyService.appLogout(ticket).subscribe({
      next: (resp) => {
        if (this.signoutLink) {
          this.showSignOutLoader = false;
          this.signoutLink.nativeElement.click();
        }
      },
      error: (error) => {
        if (this.signoutLink) {
          this.showSignOutLoader = false;
          this.signoutLink.nativeElement.click();
        }
      }
    });
  }

  
  navigateToEmailPreview() {
    sessionStorage.setItem("previousUrl", this.router.url);
    sessionStorage.setItem("routename", "contactadmin");
    this.router.navigate(['/emailpreview'])
  }

  isHomePage(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return (currentUrl === '/');
  }
  
  openURl(url) {
    window.open(url, "_blank");
  }

  hoverIn(category: string): void {
    this.hover_megamenu = category;

  }

  removeConfigureMFAForFederatedUser() {
    const isFederatedUser = checkFederatedUser(this.getCookie('userid'));
    if (isFederatedUser === true || isFederatedUser === 'true') {
      this.menuLists = this.menuLists.filter(item => item.id !== 17);
    }
}


  getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let cookieName = name + "=";
    let c: string;

    for (const cookie of ca) {
      if (cookie.indexOf(name, 0) > -1) {
        c = cookie.substring(cookieName.length + 1, cookie.length);
        return c;
      }
    }
    return "";
  }
}

